import numeral from 'numeral'

let financialOutItems = [
  {
    name: {
      zh: '人事費用',
      en: 'Personnel Expenses',
    },
    price: 215232224.48,
  },
  {
    name: {
      zh: '運營費用',
      en: 'Operating Expenses',
    },
    price: 72169596.76,
  },
  {
    name: {
      zh: '校園改善工程及設備購置',
      en: 'Campus Construction and Equipment Consumption',
    },
    price: 6693710.13,
  },
  {
    name: {
      zh: '其他',
      en: 'Others',
    },
    price: 3937809.46,
  },
]
const sumFinancialOutAmount = financialOutItems.reduce((prev, current) => prev + current.price, 0)
financialOutItems = financialOutItems.map((item) => ({
  ...item,
  priceInDisplay: numeral(item.price, true).format('0,0.00'),
  percentage: numeral(Math.round(Math.round(item.price/sumFinancialOutAmount*10000)/10)/10).format('0.0') + '%',
}))

let financialInItems = [
  {
    name: {
      zh: '旅遊基金',
      en: 'Tourism Fund',
    },
    price: 38000000,
  },
  {
    name: {
      zh: '政府撥款',
      en: 'Government Subvention',
    },
    price: 194107192,
  },
  {
    name: {
      zh: '學費',
      en: 'Tuition Fees',
    },
    price: 51116858.17,
  },
  {
    name: {
      zh: '服務及其他活動',
      en: 'Services and Other Activities',
    },
    price: 13088439.8,
  },
  {
    name: {
      zh: '上年度結餘',
      en: "Balance Brought Forward from Last Year",
    },
    price: 16529087.48,
  },
  {
    name: {
      zh: '其他',
      en: 'Others',
    },
    price: 4061234.4,
  },
]
const sumFinancialInAmount = financialInItems.reduce((prev, current) => prev + current.price, 0)
financialInItems = financialInItems.map((item) => ({
  ...item,
  priceInDisplay: numeral(item.price, true).format('0,0.00'),
  percentage: numeral(Math.round(Math.round(item.price/sumFinancialInAmount*10000)/10)/10).format('0.0') + '%',
}))

export {
  sumFinancialOutAmount,
  sumFinancialInAmount,
  financialOutItems,
  financialInItems,
}
